<template>


	<!-- <div id="app"> -->
		<router-view ref="view">
		</router-view>
	<!-- </div> -->
	
	
</template>

<style lang="scss">

	html {
	  height: 100%;
	}
	body {
		display: block;
		margin: 0;
	  min-height: 100%;
	  position: relative;
	  overflow-x: hidden;
	  &:before {
	    content: "";
	    position: absolute;
	    z-index: -1;
	    top: 0px;
	    left: 0px;
	    bottom: 0px;
	    right: 0px;
	  }
	}

	@import '../../node_modules/font-awesome/css/font-awesome.min.css';
	@import '../../node_modules/sweetalert2/dist/sweetalert2.min.css';
	@import '../../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
	@import '../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
	@import '../../node_modules/vue2-dropzone/dist/vue2Dropzone.css';
	@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,300italic);

</style>

<script>
	
	
	// The app.
	
	export default {
		
		
		name: 'App'


	};


</script>



// WEBPACK FOOTER //
// src/custom/_App.vue